// import React from "react";
import { Component } from "react";
import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
import { getBoundingClientRect } from "../../utils/functions";
import { checkTranslation, translate } from "../../utils/useful";
// import LoaderButton from "../LoaderButton";
// import CardBuilder from "./CardBuilder";
import HttpServices from "../../utils/Http.services";
import ButtonAnimated from "../buttons/ButtonAnimated";
import * as actions from '../../stores/actionsList';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CustomLoader from "../CustomLoader";
import SwitchInput from "./SwitchInput";
import SidebarView from "../SidebarView";
import FormViewer from "../FormViewer";

class FrameSynchronizations extends Component {

  state = {
    characters: [],
    search: "",
    headers: [
      { key: 'frame', type: 'FrameSelectInput', information: { isSearchable: true, multiple: false, label: '{{lang}}Target frame', address: 'getFramesApplet', filter: { appletPopulate: true, appletHub: '{{appletHub}}', type: ['collection', 'folder'] }, fields: { title: 'name', value: '_id', image: 'image', mainParent: 'applet', parent: 'parents', type: 'type', mode: 'mode', name: 'name', cDate: 'cDate', applet: 'applet' }, type: 'api', placeholder: '{{lang}}Select frames ...', hint: "{{lang}}If you don't have access for confirming this sync for this target frame, a request will the sent to the target frame's admin and the sync with take effect if they approve this synchronization.", required: true }, },
      { key: 'type', type: 'SelectInput', col: '12', information: { label: '{{lang}}Sync type', type: 'local', items: [{ value: 'fields', title: '{{lang}}Fields', description: 'Syncing fields means that fields from one frame will be synchronized with another frame — either in one direction or both, depending on the selected sync direction.' }, { value: 'records', title: '{{lang}}Records', description: '{{lang}}Syncing records means that data from one frame will be synchronized with another frame — either in one direction or both, depending on the selected sync direction.' }], placeholder: '{{lang}}Select', required: true } },
      { key: 'direction', type: 'SelectInput', col: '12', information: { label: '{{lang}}Sync direction', type: 'local', items: [{ value: 'in', title: '{{lang}}Inbound sync (Target → This Frame)', description: '{{lang}}Import and sync records or fields from the target frame into this frame.' }, { value: 'out', title: '{{lang}}Outbound sync (This Frame → Target)', description: "{{lang}}Export and sync records or fields from this frame to the target frame." }, { value: 'both', title: '{{lang}}Sync Both Ways (↔)', description: "{{lang}}Automatically sync records or fields between both frames in both directions." }], placeholder: '{{lang}}Select', required: true } },
    ],

  };

  componentDidMount() {
    this.fetchData()
  }



  fetchData = () => {

    // console.log(this.props.page)
    // let relatedFrames = this.props.page?.relatedFrames
    // let list = []

    // if (Array.isArray(relatedFrames)) {

    //   for (let i = 0; i < relatedFrames.length; i++) {
    //     let relatedFrame = relatedFrames[i];
    //     if (relatedFrame.settings.field) {
    //       for (let f = 0; f < relatedFrame.frame?.fields.length; f++) {
    //         const field = relatedFrame.frame?.fields[f];
    //         if (field.key == relatedFrame.settings.field) {
    //           relatedFrame.settings.fullField = field
    //         }
    //       }
    //     }
    //     list.push(relatedFrame)
    //   }
    // }


    // // console.log(list)

    // this.setState({ list })

    // // this.setState({ isLoading: true })
    let body = {
      frame: this.props.page?._id
    }

    this.setState({ isLoading: true })

    HttpServices.request('getSyncedFramesList', body, (fetchResult, fetchError) => {


      console.log('FETCH', fetchResult, fetchError);
      this.setState({ isLoading: false })

      if (fetchError) {
        this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
        return
      }

      this.setState({ list: fetchResult.info })

    })
  }

  onDragEnd = (result) => {
    let items = Array.from(this.state.characters);
    let [reorderItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderItem);
    this.setState({ characters: items }, () => {
    });
  };

  searchInput = (e) => {
    this.setState({ search: e.target.value }, () => {
      this.filterHandler();
    });
  };

  changeHide = (data, index) => {
    let characters = this.state.characters
    if (characters[index].showMain == undefined) {
      characters[index].showMain = true
    }
    characters[index].showMain = !characters[index].showMain
    this.setState({ characters })
  }

  submitInfo = () => {
    let data = { _id: this.props.page._id, view: this.props.view?.id, }
    // console.log('this.props.view90', this.props.view)
    data.fields = this.state.characters
    data.setting = 'customized'
    this.setState({ isLoadingPost: true })
    // console.log('data.fields', data.fields)
    HttpServices.request('updateFieldsView', data, (fetchResult, fetchError) => {
      this.setState({ isLoadingPost: false })
      if (fetchError) {
        this.props.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
      }
      // if (this.props.changeValue) {
      //   this.props.changeValue(item)
      // }
      if (fetchResult.info) {
        // console.log('fetchResult.info.views', fetchResult.info.views)
        this.props.setViews(fetchResult.info.views)
      }
      this.props.closeSide('synchronizationsSide')
    })
  }




  filterHandler = () => {
    let fields = [...this.props.page.fields];
    let temp = [];
    for (let i = 0; i < fields.length; i++) {
      let content = fields[i];
      if (content.information.label.toLowerCase().includes(this.state.search.toLowerCase())) {
        temp.push(content);
      }
    }
    this.setState({ characters: temp });
  }



  close = () => {
    this.props.closeSide('synchronizationsSide')
  }



  changeSwitchValue = (key, value, extra) => {


  }

  openForm = (data) => {

    this.setState({ currentData: data }, () => {

      this.formSide.open()
    })
  }


  render() {
    return (
      <div ref={el => this.scrollContainer = el} className="w-100 h-100  " style={{}}>
        {/* <div className="flexcb px-2 py-1" style={{ position: 'sticky', top: 0, zIndex: 1, boxShadow: '0px 0px 30px #10101010', borderBottom: '1px solid #f6f6f6', background: this.props.background ?? 'linear-gradient(to right, #fff , #fff)', backgroundColor: '#fff' }}>
          <p className="text-bold py-1 px-2">{translate('Customize Card')}</p>
        </div> */}
        <div className='flexcb  position-sticky top-0 w-100' style={{ padding: '6px 14px', background: this.props.colors ? this.props.colors.background : 'linear-gradient(90deg, #fff, #fff)', zIndex: 2, borderBottom: '1px solid #eee', }}>
          <div className='flexc'>
            {this.state.backbtn == true &&
              <button onClick={this.BackStage}>
                <img width={18} className='mrd-2 flexcc invert' src='/assets/icons/arrow-left-white.svg' alt="" />
              </button>
            }
            <p className=' font-size-14 text-semibold' style={{ color: this.props.colors?.textColor ?? '#fff' }}>{translate('Synchronizations')}</p>
          </div>
          <div className="flexc">
            <div className="px-1">
              <ButtonAnimated
                // iconwidth='24px'
                onClick={() => { this.close() }}
                title={translate('Cancel')}
                // icon='/assets/icons/plus-white.svg'
                textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                isLoading={this.state.isLoadingPost}
                bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                invert={!this.props.colors?.iconInvert}

                width={'100%'}
              />
            </div>
            <ButtonAnimated
              iconwidth='24px'
              onClick={this.state.isLoadingPost ? () => { } : () => { this.submitInfo() }}
              title={translate('Submit')}
              icon='/assets/icons/plus-white.svg'
              textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
              isLoading={this.state.isLoadingPost}
              bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
              invert={!this.props.colors?.iconInvert}

              width={'100%'}
            />
          </div>

        </div>
        <div className='scroll-no-scrollbar' style={{ height: 'calc(100% - 60px)' }}>

          <div className="px-1 pt-1">
            {/* 
            <div className="text-small text-semibold px-2 pt-2 pb-1" style={{}}>
              <p>{translate('Fields to show')}</p>
            </div> */}
            {/* <div className="px-1 py-1">
              <div className="fields-search flexc p-1 w-100 br-4 mt-1" style={{ backgroundColor: '#f6f6f6' }}>
                <img src="/assets/icons/gantt/search.svg" className="mld-1" height={12} alt="" />
                <input value={this.state.search} onChange={(e) => this.searchInput(e)} type="text" name="name" className="fields-search text-smaller p-1" style={{ backgroundColor: 'transparent', borderBottom: "none", width: "100%" }} placeholder={translate("Find a field")} />
              </div>
            </div> */}
            <div style={{ position: "fixed", top: "0", left: "0" }} ref={(el) => (this.setPositionDiv = el)}></div>

            {(!this.state.isLoading && this.state.list?.length == 0) && (
              <div className="px-2 py-3">
                <p className="font-size-14 text-semibold">{translate("No synchronization found")}</p>
                <p className="font-size-12 mt-1">{translate("Synchronizations will help automatic sync of freilds and/or records between two frames.")}</p>
                <button className="text-link mt-1" onClick={() => this.openForm()}>{translate("+ Add new synchronization")}</button>
              </div>
            )}


            {this.state.isLoading && (
              <div className="pt-3 w-100 flexcc ">
                <CustomLoader isLoading={true} />
              </div>
            )}

            {this.state.list?.length > 0 && (

              <div className="flexc scroll-no-scrollbar " style={{ background: '#f0f0f0', flexDirection: "column", alignItems: "flex-start", }}>



                <div className="flexc  w-100 p-2">
                  {/* <div style={{ width: 20 }}>

                  </div> */}
                  <div className="prd-2" style={{ flex: 2 }}>
                    <p className="font-size-13 text-semibold">{translate("Frame")}</p>
                  </div>

                  <div className="prd-2" style={{ flex: 1 }}>
                    <p className="font-size-13 text-semibold">{translate("Fields")}</p>
                  </div>

                  <div className="prd-2" style={{ flex: 1 }}>
                    <p className="font-size-13 text-semibold">{translate("Records")}</p>
                  </div>

                  <div style={{ width: 15 }}>
                    {/* <p className="font-size-13 text-semibold" style={{whiteSpace:'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', }}>{translate("Settings")}</p> */}
                  </div>

                </div>



                <DragDropContext onDragEnd={(result) => this.onDragEnd(result)}>
                  <Droppable droppableId="droppable">
                    {(provided) => (
                      <div className="w-100" style={{ transform: "none" }} {...provided.droppableProps} ref={provided.innerRef}>
                        {Array.isArray(this.state.list) && this.state.list.map((item, index) => {
                          // console.log(item)
                          return (
                            <Draggable key={item.key} draggableId={item.key} index={index}>
                              {(provided, snapshot) => {
                                if (snapshot.isDragging) {
                                  if (!provided.draggableProps) {
                                    provided.draggableProps = { style: { boxShadow: "0px 0px 30px #10101090", zIndex: "10" } };
                                  }
                                  let bound = getBoundingClientRect(this.setPositionDiv);
                                  // let scrollTop = this.scrollContainer.scrollTop
                                  const offset = { x: bound.left, y: bound.top };
                                  let x = (provided.draggableProps?.style?.left ?? 0) - offset.x;
                                  let y = (provided.draggableProps?.style?.top ?? 0) - offset.y;
                                  // y = y - scrollTop
                                  provided.draggableProps.style.left = x + 'px';
                                  provided.draggableProps.style.top = y + 'px';
                                  provided.draggableProps.style.boxShadow = "0px 0px 10px #10101020";
                                  provided.draggableProps.style.zIndex = "10";
                                }
                                return (
                                  <div className="fields-box w-100" style={{ borderBottom: '1px solid #f0f0f0' }}>
                                    <div className="fields flexcb p-2" style={{ transform: "none" }} ref={provided.innerRef} {...provided.draggableProps}>
                                      <div className="d-flex w-100">

                                        {/* <div style={{ width: 20 }} {...provided.dragHandleProps}>
                                          <img className="" style={{ opacity: 0.8 }} src="/assets/icons/drag-and-drop.svg" width="13px" alt="" />
                                        </div> */}
                                        {/* <Switch onChange={this.handleChange} checked={this.state.checked} /> */}
                                        {/* <img src={item.src} className="mx-1" style={{ width: "10px" }} /> */}
                                        <div className="prd-2" style={{ flex: 2 }}>
                                          <p className="font-size-13 text-semibold" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', }}>{checkTranslation(item?.frame?.name)}</p>
                                          <p className="font-size-12 text-semibold" style={{ color: "#777", whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', }}>{translate('Collection')}</p>
                                        </div>

                                        <div className="prd-2" style={{ flex: 1 }}>
                                          <p className="font-size-13 text-semibold" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', }}>{checkTranslation(item?.settings?.fullField?.information?.label)}</p>
                                          <p className="font-size-12 text-semibold" style={{ color: "#777", whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', }}>{translate('Field')}</p>

                                        </div>

                                        <div style={{ flex: 1 }} title={translate("Be visible as a tab in the single record admin view.")}>
                                          {/* <label class="switch " >
                                          <input type="checkbox" checked={item?.showMain == undefined || item?.showMain} onChange={() => this.changeHide(item, index)} />
                                          <span class="slider round"></span>
                                        </label> */}

                                          <SwitchInput header={{ key: '', information: {} }} data={true} changeValue={this.changeSwitchValue} />
                                        </div>

                                        <div style={{ width: "15px" }} className=" cursor-poiner">
                                          <img className="" style={{ opacity: 0.8 }} src="/assets/icons/useful/settings.png" width="13px" alt="" />
                                        </div>


                                      </div>

                                    </div>
                                  </div>
                                );
                              }}
                            </Draggable>
                          );

                        })}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            )}
            {/* <div className="fields-buttons flexcb p-2 pt-1 w-100" style={{}}>
            <button className="fields-button text-smaller w-100 mrd-1" onClick={() => this.hideAllHandler()}>
              Hide all
            </button>
            <button className="fields-button text-smaller w-100 mld-1" onClick={() => this.showAllHandler()}>
              Show all
            </button>
          </div> */}
          </div>
        </div>



        <SidebarView ref={e => this.formSide = e} width={this.props.width} widthCondition={{ xs: "85%", sm: "60%", md: '50%', lg: "40%", xl: "30%" }}>


          <div className="w-100" style={{ overflow: 'auto' }}>


            <div className='flexcb  position-sticky top-0 w-100' style={{ padding: '6px 14px', background: this.props.colors ? this.props.colors.background : 'linear-gradient(90deg, #fff, #fff)', zIndex: 2, borderBottom: '1px solid #eee', }}>

              <div className='flexc'>
                {this.state.backbtn == true &&
                  <button onClick={this.BackStage}>
                    <img width={18} className='mrd-2 flexcc invert' src='/assets/icons/arrow-left-white.svg' alt="" />
                  </button>
                }
                <p className=' font-size-14 text-semibold' style={{ color: this.props.colors?.textColor ?? '#fff' }}>{this.state.currentData?._id ? translate('Edit sync') : translate('Add new sync')}</p>
              </div>


              <div className="flexc">
                <div className="px-1">
                  <ButtonAnimated
                    onClick={() => { this.formSide.close() }}
                    title={translate('Cancel')}
                    // icon='/assets/icons/plus-white.svg'
                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                    isLoading={this.state.isLoadingPost}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                    invert={!this.props.colors?.iconInvert}

                    width={'100%'}
                  />
                </div>
                <ButtonAnimated
                  iconwidth='24px'
                  onClick={this.state.isLoadingPost ? () => { } : () => { this.submitInfo() }}
                  title={translate('Submit')}
                  icon='/assets/icons/plus-white.svg'
                  textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                  isLoading={this.state.isLoadingPost}
                  bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                  invert={!this.props.colors?.iconInvert}

                  width={'100%'}
                />
              </div>

            </div>

            {/* {console.log(this.props.variables)} */}

            <FormViewer ref={el => this.form = el} initData={this.state.currentData} headers={this.state?.headers} formClass="bordered-form" inputClass={'bordered-input'} params={this.props.params} variables={this.props.variables} />


          </div>


        </SidebarView>
      </div>
    );
  }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user, connections: state.connections })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(FrameSynchronizations);